import {
    ActionIcon,
    Badge,
    Box,
    Button,
    Checkbox,
    Flex,
    Group,
    Stack,
    Text,
} from '@mantine/core';

import EditLinkModal from '../modals/EditLink';
import { IconPlus } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';

const LinksToolbarActions = ({
    filterOptions,
    rightSection,
    actionButtons: ToolbarActions,
    showHidden,
    toggleShowHidden,
    linkGroup,
}) => {
    const [
        createGroupOpened,
        { open: openCreateModal, close: closeCreateModal },
    ] = useDisclosure();

    return (
        <>
            <Flex
                px={'md'}
                w={'100%'}
                align={'center'}
                justify={'flex-end'}>
                <Button
                    size={'compact-xs'}
                    leftSection={
                        <IconPlus
                            style={{ width: '70%', height: '70%' }}
                            stroke={1.5}
                        />
                    }
                    styles={{
                        section: {
                            marginInlineEnd: 0,
                        },
                    }}
                    onClick={openCreateModal}>
                    New Link
                </Button>
                <Group
                    ms={'xs'}
                    gap={'xs'}
                    align={'center'}>
                    {ToolbarActions ? <ToolbarActions /> : null}
                    <Checkbox
                        label={'Show Hidden'}
                        value={showHidden}
                        onChange={toggleShowHidden}
                    />
                </Group>
            </Flex>
            <EditLinkModal
                linkGroup={linkGroup}
                opened={createGroupOpened}
                close={closeCreateModal}
            />
        </>
    );
};
export default LinksToolbarActions;
